import type { EditNodeSuggestion, SuggestionProvider } from "../types";

export const editNodeSuggestionProvider: SuggestionProvider = {
  type: "editNode",
  search: (_str, doc) => {
    const { pointerNode } = doc.editor.suggestions;
    const canEdit = pointerNode
      ? pointerNode.isEditable
      : doc.selection.hasSelectedEditableNode && doc.selection.isMathOnlySelection;

    if (canEdit) {
      return [
        [
          {
            type: "editNode",
            trackingId: "edit_node",
            icon: "Rename",
            popupGroup: "transform",
            priority: 4,
          } as EditNodeSuggestion,
        ],
      ];
    }

    return [];
  },
};
